(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerLibrarySearch',
	};

    $(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.modal').on('click', '.lp-library-search-clear', function _clearForm(e) {
			e.preventDefault();

			Adzuki.Ajax.get('/LivePlanner/sessionLibrary/1')
			.then(function success(content) {

				$('.modal').find('.modal-body').html(content);

				Adzuki.Form.initAjaxForm('LivePlannerLibrarySearch');
			});
		});
	};

    form.success = function success(response)
	{
		var from = $('#liveplannerlibrarysearch-from').val();

		if (!Adzuki.Form.hasError(response)) {
			if (from === 'session') {
				Adzuki.Ajax.get('/LivePlanner/sessionLibrary/')
				.then(function success(content) {

					$('.modal').find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerLibrarySearch');
				});

			} else {
				// eslint-disable-next-line no-lonely-if
				if (response['status'] === 'success') {
					window.location.href = response['data'];
					return true;
				}
			}
        }

		return false;
    };
}(jQuery, window.Adzuki || {}));